<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Parts / actions",
          icon: "bi bi-pie-chart-fill",
          route: "shares-index",
        },
        {
          label: "Nouvelle entrée",
          icon: "bi bi-plus-circle-fill",
          route: "shares-create",
        },
      ],
    };
  },
};
</script>
